import React from "react";
import { Route } from "react-router";
import styled from "styled-components";
import HeaderOrbit from "../HeaderOrbit";
import Footer from "../Footer";

type HomeTemplateProps = {
  Component: any;
  path?: any;
  exact?: any;
};

const HomeTemplate: React.FC<HomeTemplateProps> = ({ Component, ...props }: any) => {
  return (
    <>
      <Route
        {...props}
        render={(propsRoute) => {
          return (
            <BoxBg>
              <HeaderOrbit />
              <Component {...propsRoute} />
              <Footer />
            </BoxBg>
          );
        }}
      />
    </>
  );
};

export const HomeTemplateV2: React.FC<HomeTemplateProps> = ({ Component, ...props }: any) => {
  return (
    <>
      <Route
        {...props}
        render={(propsRoute) => {
          return (
            <BoxBg>
              <Component {...propsRoute} />
              <Footer />
            </BoxBg>
          );
        }}
      />
    </>
  );
};

export default HomeTemplate;

const BoxBg = styled.div`
  position: relative;
  /* background-image: url("/assets/home/backgroundV1.png") */
`;
